import dayjs from "dayjs";
import {
    IoChevronBack,
    IoChevronForward
} from "react-icons/io5";
import {
    Bar,
    BarChart,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";

export default function MonthlyAttendanceChart({ data, attendanceMonth, onPrevious, onNext, onCurrentMonth }) {
    const isThisMonth = attendanceMonth.isSame(dayjs(), "month");
    return (
        <div className="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">

            <div className="mb-5 flex items-center justify-between">

                <div>
                    <h3 className="text-lg font-bold text-[#0B6BCB]">
                        Monthly Attendance
                    </h3>

                    <p className="text-xs text-gray-400">
                        {attendanceMonth.format("MMMM YYYY")}
                    </p>
                </div>

                <div className="flex items-center gap-2">

                    <button
                        onClick={onPrevious}
                        className="flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 transition hover:bg-gray-100"
                    >
                        <IoChevronBack size={16} />
                    </button>

                    <button
                        onClick={onCurrentMonth}
                        disabled={isThisMonth}
                        className={`rounded-full px-3 py-1.5 text-xs font-semibold transition
    ${isThisMonth
                                ? "cursor-not-allowed bg-gray-200 text-gray-500"
                                : "bg-[#0B6BCB] text-white hover:bg-[#0957a5]"
                            }`}
                    >
                        This Month
                    </button>


                    <button
                        onClick={onNext}
                        className="flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 transition hover:bg-gray-100"
                    >
                        <IoChevronForward size={16} />
                    </button>

                </div>

            </div>

            <ResponsiveContainer width="100%" height={360}>
                <BarChart data={data} barSize={18}>
                    <CartesianGrid
                        strokeDasharray="3 3"
                        vertical={false}
                    />

                    <XAxis
                        dataKey="date"
                        tick={{ fontSize: 11 }}
                    />

                    <YAxis />

                    <Tooltip />

                    <Legend />

                    <Bar
                        dataKey="Present"
                        stackId="attendance"
                        fill="#00CC00"
                        radius={[4, 4, 0, 0]}
                    />

                    <Bar
                        dataKey="Absent"
                        stackId="attendance"
                        fill="#bebebe"
                        radius={[4, 4, 0, 0]}
                    />
                </BarChart>
            </ResponsiveContainer>

        </div>
    );
}